import siteService from "./siteService";
import { useViewerStore } from "../store/store";
import { DesignData } from "../@types/types";

export async function getDesignVersionList(salesforceId: string): Promise<DesignData[] | null> {
  const response = await siteService.retrieveSiteDesignDetails(salesforceId);
  if (response?.Message === "No records found") {
    useViewerStore.setState({ siteDesignDetails: response });
    return null;
  }

  if(response[0].NonFinalizedDesign.length > 0){
    useViewerStore.setState({isNonFinalizedSavedDesign: true});
    useViewerStore.setState({nonFinalizedDesignData: response[0].NonFinalizedDesign[0].Design[0]});
    return null;
  }

  useViewerStore.setState({
    selectedLossesVendor: response[0].Design[0].MultipliersVendor,
    efficiencyOverride: response[0].Design[0].TsrfEfficiencyOverride,
    SFannualUsage: response[0].Design[0].Buildings[0].Max_System_Size_Electric_Load,
    siteBuildingData: response[0].Design[0].Buildings,
    siteDesignDetails: response,
  });

  const activeDesign = response[0].Design;
  const inactiveDesign = response[0].InactiveDesign;

  inactiveDesign.sort((a: any, b: any) => {
    if (a.Design_No > b.Design_No) {
      return -1;
    } else if (a.Design_No < b.Design_No) {
      return 1;
    } else {
      return b.Version_No - a.Version_No;
    }
  });

  return [...activeDesign, ...inactiveDesign];
}
